import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {GeneralComponent} from './general.component';
import {ApplicationFormComponent} from './application-form/application-form.component';

const routes: Routes = [
  {
    path: 'home',
    component: GeneralComponent,
    data: {
      title: 'Home',
      pageTitle: 'General - Home : Vivekananda Global University Jaipur',
      breadcrumb: 'Home'
    }
  },
  {
    path: 'application-form',
    component: ApplicationFormComponent,
    data: {
      title: 'Application Form',
      pageTitle: 'General - Application Form : Vivekananda Global University Jaipur',
      breadcrumb: 'Application Form'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class GeneralRoutingModule {
}
